// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_AtualizarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for PUT /payments/accounts/atualizar/{id}
 *
 * Returns the updated sanitized subaccount object (subaccounts_model
 * ->getById() run through sanitizeForFrontend()) — the identical shape the
 * sibling atualizar_config endpoint returns, so the typed
 * SubaccountsFranchises_AtualizarConfigRow is reused here. The only free-form
 * members are the 5 decoded-JSON blobs (config/fiscal_config/
 * anticipation_config/address/bank_account), declared as justified
 * shape-erased arrays on that Row.
 */
import type { SubaccountsFranchises_AtualizarConfigRow } from './SubaccountsFranchises_AtualizarConfigRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_AtualizarResponseDados = SubaccountsFranchises_AtualizarConfigRow;

export type SubaccountsFranchises_AtualizarResponse = ApiResponse<SubaccountsFranchises_AtualizarResponseDados>;

registerResponseContract('SubaccountsFranchises_AtualizarResponse', {
  id:                  { type: 'number',  required: true },
  provider_id:         { type: 'number',  required: true },
  provider_account_id: { type: 'string',  required: false },
  wallet_id:           { type: 'string',  required: false },
  api_key:             { type: 'string',  required: false },
  name:                { type: 'string',  required: true },
  email:               { type: 'string',  required: false },
  document:            { type: 'string',  required: false },
  document_type:       { type: 'string',  required: false },
  phone:               { type: 'string',  required: false },
  address:             { type: 'object',  required: false },
  bank_account:        { type: 'object',  required: false },
  status:              { type: 'string',  required: true },
  config:              { type: 'object',  required: false },
  fiscal_config:       { type: 'object',  required: false },
  sandbox_mode:        { type: 'number',  required: true },
  webhook_token:       { type: 'string',  required: false },
  last_sync_at:        { type: 'string',  required: false },
  created_at:          { type: 'string',  required: true },
  updated_at:          { type: 'string',  required: true },
  anticipation_config: { type: 'object',  required: false },
  provider_code:       { type: 'string',  required: true },
  provider_name:       { type: 'string',  required: true },
  api_base_url:        { type: 'string',  required: true },
  sandbox_api_url:     { type: 'string',  required: true },
  franchises: {
    type: 'array',
    required: false,
    items: {
      id:           { type: 'number',  required: true },
      franchise_id: { type: 'number',  required: true },
      created_at:   { type: 'string',  required: false },
      franquia:     { type: 'string',  required: false },
    },
  },
})
